// Module
var code = "<div id=\"V-83C2FC03-5925-4F00-8CA3-2942961B7413\"> <div class=\"V-83C2FC03-5925-4F00-8CA3-2942961B7413-chart\" data-b-class-titlertl=\"{Binding titlertl}\"></div> </div> ";
// Exports
export default code;